const C = {
  name: "Bucket",
  dimensions: { width: 20, height: 20 },
  content: `
    <g>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M1 0C0.447715 0 0 0.447715 0 1C0 1.55228 0.447715 2 1 2H2.05401L2.89659 17.1664C2.98491 18.7562 4.29977 20 5.89197 20H14.108C15.7002 20 17.0151 18.7562 17.1034 17.1664L17.2256 14.9671C17.4808 14.9889 17.7391 15 18 15H19C19.5523 15 20 14.5523 20 14C20 13.4477 19.5523 13 19 13H18C17.7763 13 17.555 12.9895 17.3366 12.969L17.946 2H19C19.5523 2 20 1.55228 20 1C20 0.447715 19.5523 0 19 0H1ZM15.3604 12.4852L15.9429 2H4.0571L4.89351 17.0555C4.92295 17.5854 5.36124 18 5.89197 18H14.108C14.6388 18 15.077 17.5854 15.1065 17.0555L15.2445 14.5704C11.6218 13.4065 9 10.0094 9 6V5C9 4.44772 9.44771 4 10 4C10.5523 4 11 4.44772 11 5V6C11 8.93213 12.8028 11.4432 15.3604 12.4852Z" fill="currentColor"/>    
    </g>
    `
};
export {
  C as Bucket
};
